import { BufferAttribute, BufferGeometry, DoubleSide, Matrix4, Mesh, MeshPhongMaterial, Points, PointsMaterial, Quaternion, Vector3, } from "three";
import { Simulator } from "./Simulator";
import { FloatArray } from "./type";
Simulator.prototype.addHybrid = function (state) {
    this.hybrid = state;
    // add articulated
    let n_articulated = state.n_articulated();
    for (let i = 0; i < n_articulated; i++) {
        let n_bodies = state.n_bodies_articulated(i);
        for (let j = 0; j < n_bodies; j++) {
            let frame = state.frame_articulated_body(i, j);
            let n_visuals = state.n_visuals_articulated_body(i, j);
            for (let k = 0; k < n_visuals; k++) {
                let iso = state.iso_visual_to_body(i, j, k);
                let q = new Quaternion(iso[0], iso[1], iso[2], iso[3]);
                let t = new Vector3(iso[4], iso[5], iso[6]);
                let visual_offset = new Matrix4().compose(t, q, new Vector3(1, 1, 1)); // last arg is unit scale
                let visual_type = state.visual_type(i, j, k);
                let visual_name = frame + "-" + k;
                if (visual_type == 0) {
                    if (state.visual_show(i)) {
                        let r = state.visual_sphere_r(i, j, k);
                        this.addSphere(visual_name, 0xff0000, r, visual_offset);
                    }
                }
                else if (visual_type == 1) {
                    if (state.visual_show(i)) {
                        let wdh = state.visual_cuboid_wdh(i, j, k);
                        this.addCuboid(visual_name, 0xff0000, wdh[0], wdh[1], wdh[2], visual_offset);
                    }
                }
                else if (visual_type == 2) {
                    let vertices = state.visual_mesh_vertices(i, j, k);
                    let faces = state.visual_mesh_faces(i, j, k);
                    let visual_color = state.visual_color(i, j, k);
                    this.addRigidMesh(visual_name, visual_color, vertices, faces, visual_offset, state.visual_mesh_groups(i, j, k), state.visual_mesh_group_colors(i, j, k));
                }
                else if (visual_type == 3) {
                    if (state.visual_show(i)) {
                        let r = 0.002; // default visual size for point
                        this.addSphere(visual_name, 0xff0000, r, visual_offset);
                    }
                }
                else {
                    alert(`unknown visual type: ${visual_type}`);
                }
            }
        }
    }
    // add deformables
    let all_nodes = state.deformable_nodes();
    let dofs = state.deformable_dofs();
    let nodes_array = [];
    let offset = 0;
    for (let i = 0; i < dofs.length; i++) {
        const dof = dofs[i];
        nodes_array.push(all_nodes.subarray(offset, offset + dof));
        offset += dof;
    }
    let all_faces = state.deformable_faces();
    let face_ns = state.deformable_face_ns();
    if (dofs.length != face_ns.length) {
        alert("dof.len != face_ns.len");
    }
    let faces_array = [];
    offset = 0;
    for (let i = 0; i < face_ns.length; i++) {
        const face_n = face_ns[i];
        faces_array.push(all_faces.subarray(offset, offset + face_n * 3));
        offset += face_n * 3;
    }
    for (let i = 0; i < dofs.length; i++) {
        const geometry = new BufferGeometry();
        let nodes = nodes_array[i];
        geometry.setAttribute("position", new BufferAttribute(nodes, 3));
        let facets = faces_array[i];
        geometry.setIndex(new BufferAttribute(facets, 1));
        geometry.computeVertexNormals();
        const material = new MeshPhongMaterial({
            color: 0x2194ce,
            side: DoubleSide,
            flatShading: true,
            transparent: true,
            opacity: 1.0,
        });
        const mesh = new Mesh(geometry, material);
        mesh.frustumCulled = false; // prevent mesh disappearing
        this.meshes.set("deformable " + i, mesh);
        this.graphics.scene.add(mesh);
        // --- Add vertex points ---
        const pointMaterial = new PointsMaterial({
            color: 0xff0000,
            size: 0.1, // adjust for your scale
        });
        const points = new Points(geometry, pointMaterial);
        this.graphics.scene.add(points);
        // // --- Add edges overlay ---
        // const wireframeGeometry = new WireframeGeometry(geometry);
        // const wireframe = new LineSegments(
        //   wireframeGeometry,
        //   new LineBasicMaterial({ color: 0x000000 }),
        // );
        // this.graphics.scene.add(wireframe);
    }
    // Add cloths
    let cloth_nodes = state.cloth_nodes();
    let cloth_dofs = state.cloth_dofs();
    let cloth_nodes_array = []; // break array into array of arrays
    let cloth_offset = 0;
    for (let i = 0; i < cloth_dofs.length; i++) {
        const dof = cloth_dofs[i];
        cloth_nodes_array.push(cloth_nodes.subarray(cloth_offset, cloth_offset + dof));
        cloth_offset += dof;
    }
    let cloth_faces = state.cloth_faces();
    let cloth_face_ns = state.cloth_face_ns();
    if (cloth_dofs.length != cloth_face_ns.length) {
        alert("cloth_dofs.len != cloth_face_ns.len");
    }
    let cloth_faces_array = [];
    cloth_offset = 0;
    for (let i = 0; i < cloth_face_ns.length; i++) {
        const face_n = cloth_face_ns[i];
        cloth_faces_array.push(cloth_faces.subarray(cloth_offset, cloth_offset + face_n * 3));
        cloth_offset += face_n;
    }
    for (let i = 0; i < cloth_dofs.length; i++) {
        const geometry = new BufferGeometry();
        let nodes = cloth_nodes_array[i];
        geometry.setAttribute("position", new BufferAttribute(nodes, 3));
        let faces = cloth_faces_array[i];
        geometry.setIndex(new BufferAttribute(faces, 1));
        geometry.computeVertexNormals();
        const material = new MeshPhongMaterial({
            color: 0x2194ce,
            side: DoubleSide,
            flatShading: true,
            transparent: true,
            opacity: 1.0,
        });
        const mesh = new Mesh(geometry, material);
        mesh.frustumCulled = false; // prevent mesh disappearing
        this.meshes.set("cloth " + i, mesh);
        this.graphics.scene.add(mesh);
        // --- Add vertex points ---
        const pointMaterial = new PointsMaterial({
            color: 0xff0000,
            size: 0.1, // adjust for your scale
        });
        const points = new Points(geometry, pointMaterial);
        this.graphics.scene.add(points);
        // // --- Add edges overlay ---
        // const wireframeGeometry = new WireframeGeometry(geometry);
        // const wireframe = new LineSegments(
        //   wireframeGeometry,
        //   new LineBasicMaterial({ color: 0x000000 }),
        // );
        // this.graphics.scene.add(wireframe);
    }
    // Add halfspaces
    if (this.showHalfspaces) {
        let halfspaces = state.halfspaces();
        for (let i = 0; i < halfspaces.length; i += 4) {
            let n = new FloatArray([
                halfspaces[i],
                halfspaces[i + 1],
                halfspaces[i + 2],
            ]);
            let dist = halfspaces[i + 3];
            this.addPlane(n, dist, 10);
        }
    }
    // Add static bodies
    for (let i = 0; i < state.n_static_bodies(); i++) {
        if (state.static_visual_show(i)) {
            let vertices = state.static_body_vertices(i);
            let faces = state.static_body_faces(i);
            let name = "static body " + i;
            this.addRigidMesh(name, [0.0, 1.0, 0.0], vertices, faces);
        }
    }
};
Simulator.prototype.updateHybrid = function () {
    let state = this.hybrid;
    // update articulated bodies poses
    let n_articulated = state.n_articulated();
    for (let i = 0; i < n_articulated; i++) {
        let n_bodies = state.n_bodies_articulated(i);
        for (let j = 0; j < n_bodies; j++) {
            let frame = state.frame_articulated_body(i, j);
            let pose = state.pose_articulated_body(i, j);
            let n_visuals = state.n_visuals_articulated_body(i, j);
            for (let k = 0; k < n_visuals; k++) {
                this.setPose(frame + "-" + k, pose);
            }
        }
    }
    // update deformable positions
    let all_nodes = state.deformable_nodes();
    let dofs = state.deformable_dofs();
    let nodes_array = [];
    let offset = 0;
    for (let i = 0; i < dofs.length; i++) {
        const dof = dofs[i];
        nodes_array.push(all_nodes.subarray(offset, offset + dof));
        offset += dof;
    }
    for (let i = 0; i < dofs.length; i++) {
        let deformable = this.meshes.get("deformable " + i);
        let nodes = nodes_array[i];
        deformable.geometry.setAttribute("position", new BufferAttribute(nodes, 3));
    }
    // update cloth positions
    let cloth_nodes = state.cloth_nodes();
    let cloth_dofs = state.cloth_dofs();
    let cloth_nodes_array = [];
    let cloth_offset = 0;
    for (let i = 0; i < cloth_dofs.length; i++) {
        const dof = cloth_dofs[i];
        cloth_nodes_array.push(cloth_nodes.subarray(cloth_offset, cloth_offset + dof));
        cloth_offset += dof;
    }
    for (let i = 0; i < cloth_dofs.length; i++) {
        let cloth = this.meshes.get("cloth " + i);
        let nodes = cloth_nodes_array[i];
        cloth.geometry.setAttribute("position", new BufferAttribute(nodes, 3));
    }
};
Simulator.prototype.addRigidMesh = function (name, color, vertices, faces, offset = new Matrix4(), groups, groupColors) {
    const geometry = new BufferGeometry();
    geometry.setAttribute("position", new BufferAttribute(vertices, 3));
    geometry.applyMatrix4(offset);
    // A mesh that named its materials (an OBJ with `usemtl`, whose colours came
    // out of the .mtl beside it) is drawn as one geometry split into groups, each
    // with its own material. The geometry stays whole -- this is a drawing
    // concern, and the mesh is still a single collider.
    //
    // One group per *colour*, not one per `usemtl` run. A CAD exporter switches
    // material every few faces -- `Top.obj` on the mobile manipulator has 1,400
    // runs of five colours -- and every group is a draw call of its own on every
    // frame: that robot was 4,800 of them a frame, and is 800 this way. So the
    // faces are regrouped by colour, in the order the colours first appear and
    // each run's faces in their own order. The same faces are drawn in the same
    // colours; only the order the GPU is handed them in changes.
    let index = faces;
    const draws = [];
    if (groups && groups.length > 0 && groupColors) {
        const byColor = new Map();
        for (let g = 0; g < groups.length / 2; g++) {
            const color = [
                groupColors[3 * g],
                groupColors[3 * g + 1],
                groupColors[3 * g + 2],
            ];
            const key = color.join(",");
            const same = byColor.get(key);
            if (same) {
                same.runs.push(g);
            }
            else {
                byColor.set(key, { color, runs: [g] });
            }
        }
        // The groups count faces; the index buffer and addGroup count indices,
        // three to a face.
        let total = 0;
        for (let g = 0; g < groups.length / 2; g++) {
            total += groups[2 * g + 1];
        }
        index = new Uint32Array(total * 3);
        let at = 0;
        for (const { color, runs } of byColor.values()) {
            const start = at;
            for (const g of runs) {
                const [first, count] = [groups[2 * g], groups[2 * g + 1]];
                index.set(faces.subarray(first * 3, (first + count) * 3), at * 3);
                at += count;
            }
            draws.push({ start, count: at - start, color });
        }
    }
    geometry.setIndex(new BufferAttribute(index, 1));
    geometry.computeVertexNormals();
    const phong = (r, g, b) => {
        const material = new MeshPhongMaterial({
            side: DoubleSide,
            flatShading: true,
        });
        material.color.setRGB(r, g, b);
        return material;
    };
    let material;
    if (draws.length > 0) {
        material = draws.map(({ start, count, color: [r, g, b] }, i) => {
            geometry.addGroup(start * 3, count * 3, i);
            return phong(r, g, b);
        });
    }
    else {
        material = phong(color[0], color[1], color[2]);
    }
    const mesh = new Mesh(geometry, material);
    mesh.frustumCulled = false; // prevent mesh from disappearing
    this.meshes.set(name, mesh);
    this.graphics.scene.add(mesh);
};
